import React, { useMemo } from "react";
import { useSelector } from "react-redux";

import { useTenantFormatter } from "components/BudgetBuilder/shared/TenantFormatter";
import Table from "components/Table";
import { budgetBuilderSelectors, tenantSelectors } from "store/selectors";
import { getLineItemsDirectCostTotal, getPeriodSubtotal, getTotalFACostsByPeriod } from "utils/budgetBuilder";

import styles from "./styles.css";


export const OverviewTotalSponsorCosts = () => {
	const { currencyFormatter } = useTenantFormatter();
	const periods = useSelector(budgetBuilderSelectors.periodRows);
	const sponsoredCostsByPeriod = useSelector(budgetBuilderSelectors.sponsoredCostsByPeriod);
	const researchTeamByPeriod = useSelector(budgetBuilderSelectors.researchTeamByPeriod);
	const { subawardCostCap = 0 } = useSelector(tenantSelectors.tenant);

	const totalCosts = useMemo(() => {
		const faCostsByPeriod = getTotalFACostsByPeriod(
			sponsoredCostsByPeriod,
			subawardCostCap,
			researchTeamByPeriod,
			periods
		);
		let result = [];
		for (let period of periods) {
			let periodTotal = 0;
			periodTotal += getLineItemsDirectCostTotal(sponsoredCostsByPeriod?.[period?.periodNumber]);
			periodTotal += getPeriodSubtotal(researchTeamByPeriod?.[period?.periodNumber], false);
			periodTotal += faCostsByPeriod[period?.periodNumber];
			result.push(periodTotal);
		}

		return result;
	}, [ periods, researchTeamByPeriod, sponsoredCostsByPeriod, subawardCostCap ]);

	const total = useMemo(
		() => totalCosts.reduce((previous, current) => previous + current, 0),
		[ totalCosts ]
	);

	return (
		<Table.Row className={`${styles.rowHeader}`}>
			<Table.Cell className={`${styles.cellAlignLeft} ${styles.rowHeaderCell}`}>
				<span className={styles.bold}>{"Total Proposed Sponsor Costs"}</span>
			</Table.Cell>
			{
				(totalCosts?.map((costForPeriod, i) => (
					<Table.Cell className={`${styles.cellAlignRight} ${styles.rowHeaderCell}`} key={`period-${i}`}>
						<span className={styles.bold}>{currencyFormatter(costForPeriod)}</span>
					</Table.Cell>
				)))
			}
			<Table.Cell className={`${styles.cellAlignRight} ${styles.rowHeaderCell}`}>
				<span className={styles.bold}>{currencyFormatter(total)}</span>
			</Table.Cell>
		</Table.Row>
	);
};
